import React, { useState } from "react";

const Footer = () => {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    enquiry: "",
  });
  const [loading, setLoading] = useState(false);

  const [success, setSuccess] = useState(false);

  const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbw6EhJ0zlHXnCEvdriBfwiNQ_IiBdP6TbzDSJ7m8w0f29sso56N8G5r4soK9ykUKYDXTw/exec";

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

const submitForm = async () => {
  try {
    setLoading(true);

    await fetch(SCRIPT_URL, {
      method: "POST",
      mode: "no-cors",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    setLoading(false);
    setSuccess(true);

    // Clear fields
    setFormData({
      name: "",
      email: "",
      mobile: "",
      enquiry: "",
    });

    setTimeout(() => {
      setShowModal(false);
      setSuccess(false);
    }, 1500);

  } catch (err) {
    setLoading(false);
    alert("Something went wrong. Try again.");
  }
};


  return (
    <>
      <footer className="bg-[#000000e1] text-white py-6 mt-10">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h3 className="text-lg font-semibold tracking-wide mb-2">
            MELSHA Business Advisors
          </h3>

          <p className="text-sm opacity-90 mb-1">📍 Our Location:</p>

          <a 
            href="https://share.google/ZTyN7fyiG8bj7Zaxz"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-blue-300 hover:text-blue-400 underline"
          >
            View on Google Maps
          </a>

          <p className="text-sm opacity-90 mt-3">
            ✉️ info@melsha.ae
          </p>

          {/* WhatsApp Button */}
          <a
            href="https://wa.me/971503521342"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-4 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-full text-sm font-medium transition"
          >
            💬 Chat on WhatsApp
          </a>

          {/* Enquiry Button */}
          <button
            onClick={() => setShowModal(true)}
            className="inline-block mt-4 ml-2 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-medium transition"
          >
            📩 Submit Enquiry
          </button>

          <div className="border-t border-gray-600 mt-4 pt-3 text-xs opacity-70">
            © {new Date().getFullYear()} MELSHA Business Advisors. All Rights Reserved.
          </div>
        </div>
      </footer>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center px-4 z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full shadow-xl">

            <h2 className="text-lg font-semibold mb-4 text-gray-800">
              Submit Your Enquiry
            </h2>

            {success ? (
              <div className="text-green-600 text-center font-semibold">
                ✔ Thank you! Your enquiry has been submitted.
              </div>
            ) : (
              <form className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    What’s your name?
                  </label>
                  <input
                    name="name"
                    type="text"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                    placeholder="Enter your name"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Email ID
                  </label>
                  <input
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                    placeholder="Enter your email"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Mobile Number
                  </label>
                  <input
                    name="mobile"
                    type="tel"
                    value={formData.mobile}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                    placeholder="Enter your mobile number"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Tell us more about your enquiry
                  </label>
                  <textarea
                    name="enquiry"
                    value={formData.enquiry}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                    rows="3"
                    placeholder="Write details here..."
                  ></textarea>
                </div>

               <button
  type="button"
  onClick={submitForm}
  disabled={loading}
  className={`w-full py-2 rounded-lg text-sm font-semibold text-white
    ${loading ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"}
  `}
>
  {loading ? (
    <div className="flex items-center justify-center gap-2">
      <span className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
      Submitting...
    </div>
  ) : (
    "Submit Enquiry"
  )}
</button>


                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="w-full mt-2 bg-gray-300 hover:bg-gray-400 text-gray-800 py-2 rounded-lg text-sm font-semibold"
                >
                  Close
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;
